import React from "react";
import { Icon } from "@iconify/react";

import classes from "./FacilitiesCard.module.css";

const FacilitiesCard = ({ facility }) => {
  return (
    <div data-aos="fade-up" className={classes["facility-card"]}>
      <div className={classes["icon-wrapper"]}>
        <Icon width={"60"} icon={facility.icon} color="white" />
      </div>
      <img className={classes["facility-image"]} src={facility.image} alt="" />
      <p className={classes["facility-title"]}>{facility.title}</p>
      <p className={classes["facility-description"]}>{facility.description}</p>
    </div>
  );
};

export default FacilitiesCard;
